import './partials/utils';
import './partials/hide-submit';
import './partials/toggle-hierarchical';
import './partials/autoswitch';
import './partials/confirm-delete';
import './partials/support-toggles';
import './partials/namefield';
import './partials/menu-icon';
import './partials/tax-required-post-type';
import './partials/autopopulate';
import './partials/back-to-top';
import './partials/toggle-panels';
